import * as supportApi from "../services/api/support";
import { SubmissionError } from 'redux-form';

export const SUPPORT_FORM_SHOW_SUBMISSION_CONFIRMATION_UPDATED = 'SUPPORT_FORM_SHOW_SUBMISSION_CONFIRMATION_UPDATED';
export const SUPPORT_FORM_INITIAL_VALUE_UPDATED = 'SUPPORT_FORM_INITIAL_VALUE_UPDATED';
export const SUPPORT_FORM_INITIAL_VALUES_RESET = 'SUPPORT_FORM_INITIAL_VALUES_RESET';

export const resetInitialValues = () => {
    return {
        type: SUPPORT_FORM_INITIAL_VALUES_RESET,
    }
}

export const updateShowSubmissionConfirmation = (show = false) => {
    return {
        type: SUPPORT_FORM_SHOW_SUBMISSION_CONFIRMATION_UPDATED,
        show,
    }
}

export const updateInitialValue = (key, value) => {
    return {
        type: SUPPORT_FORM_INITIAL_VALUE_UPDATED,
        key: key, value: value,
    }
};

function formatParams(params) {

    return {
        ...((params.service_id) && ({service_id: params.service_id})),
        ...((params.sender_email) && ({sender_email: params.sender_email})),
        ...((params.sender_full_name) && ({sender_full_name: params.sender_full_name})),
        ...((params.subject) && ({subject: params.subject})),
        ...((params.body) && ({body: params.body})),
    }
}

export function submit(params) {
    return (dispatch) => {
        params = formatParams(params);

        return supportApi
            .submitSupportTicket(params)
            .then(() => dispatch(updateShowSubmissionConfirmation(true)))
            .catch((res) => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}